import Dialog from "./Dialog";
import NotSupportDialog from "./NotSupportDialog";
// import EditorsPicksDialog from "./EditorsPicksDialog";
// TODO: use the Dialog Component
// import GetCopyDialog from "./GetCopyDialog";
import YoutubeDialog from "./YoutubeDialog";

export {
  Dialog,
  // GetCopyDialog,
  NotSupportDialog,
  YoutubeDialog
  // EditorsPicksDialog
};



// WEBPACK FOOTER //
// ./src/components/Dialogs/index.js